// Toggles data-scrolled on the announcement bar when the main header scrolls
// out of view. The CSS uses this flag to fade in the phone link, which is
// otherwise redundant while the main header is visible.
//
// Requires [data-announcement-bar], [data-header], and [data-announcement-phone] in the DOM.
const initAnnouncementPhone = () => {
  const barEl = document.querySelector('[data-announcement-bar]');
  const headerEl = document.querySelector('[data-header]');
  const phoneEl = document.querySelector('[data-announcement-phone]');

  if (!barEl || !headerEl || !phoneEl) return null;

  headerEl._announcementObserver?.disconnect();

  const observer = new IntersectionObserver(
    (entries) => {
      const [entry] = entries;
      if (!entry) return;
      barEl.toggleAttribute('data-scrolled', !entry.isIntersecting);
    },
    { threshold: 0 },
  );

  headerEl._announcementObserver = observer;
  observer.observe(headerEl);

  return () => {
    observer.disconnect();
    delete headerEl._announcementObserver;
  };
};

export default initAnnouncementPhone;
